import { createClient } from "@supabase/supabase-js";
import type { Database } from "./database.types";

const supabaseUrl =
  import.meta.env.VITE_SUPABASE_URL || "http://localhost:3001";
const supabaseAnonKey =
  import.meta.env.VITE_SUPABASE_ANON_KEY || "local-anon-key";
// Only override auth URL when explicitly configured (e.g., Docker local dev).
// Without this, GoTrue correctly derives auth URL from the main Supabase URL.
// A localhost fallback here would break session restore against cloud Supabase.
const supabaseAuthUrl = import.meta.env.VITE_SUPABASE_AUTH_URL as string | undefined;

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    ...(supabaseAuthUrl ? { url: supabaseAuthUrl } : {}),
  },
  realtime: {
    params: {
      eventsPerSecond: 10,
    },
    heartbeatIntervalMs: 15000,   // Keep-alive ping every 15s (default 30s can miss)
    reconnectAfterMs: (tries: number) => {
      // Exponential backoff: 1s, 2s, 4s, 8s, 16s, max 30s
      return Math.min(1000 * Math.pow(2, tries), 30000);
    },
  },
});

/**
 * Sync the Realtime WebSocket connection with a fresh JWT.
 * Must be called when the auth token refreshes, otherwise the
 * Realtime client keeps the stale token and gets CHANNEL_ERROR.
 */
export function syncRealtimeToken(accessToken: string): void {
  try {
    supabase.realtime.setAuth(accessToken);
    console.log('[Realtime] Access token synced');
  } catch (err) {
    console.warn('[Realtime] Failed to sync access token:', err);
  }
}